
import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
//import { Http, Response, Headers, RequestOptions, RequestMethod } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise'
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CertificateModel } from '../model/certificatemodel';
import { Request } from '@angular/http/src/static_request';
import { debug } from 'util';


@Injectable()
export class DbEcertificateService {
  baseURL: string
  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.baseURL = baseUrl;
  }

  // Login Services
  login(emailAddress, password) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + 'api/Account/Login?emailAddress=' + emailAddress + '&password=' + password)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }


  // Font Services
  getAllFont(currentPageNumber, currentPageSize, sortOrder, sortName, searchText, countryId) {    
    return new Promise(resolve => {
      this.http.get(this.baseURL + 'api/Font/GetAllFonts?currentPageNumber=' + currentPageNumber + '&currentPageSize=' + currentPageSize + '&sortOrder=' + sortOrder + '&sortName=' + sortName + '&searchText=' + searchText + '&countryId=' + countryId)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  getAllFontsForDDL(schoolId, countryId) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + 'api/Font/GetAllFontsForDDL?schoolId=' + schoolId + '&countryId=' + countryId)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  getAllSystemFontsForDDL(countryId) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + 'api/Font/GetAllSystemFontsForDDL?countryId=' + countryId)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  addFont(fontObj) {
   
    return new Promise(resolve => {
      this.http.post(this.baseURL + 'api/Font/AddFont', fontObj)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  updateFont(fontObj) {
    return new Promise(resolve => {
      this.http.post(this.baseURL + 'api/Font/UpdateFont', fontObj)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  deleteFont(fontId, deletedBy) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + "api/Font/DeleteFont?fontId=" + fontId + '&deletedBy=' + deletedBy)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  getFontByFontId(id) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + "api/Font/GetFontByFontId?id=" + id)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  isExistFont(fontId,fontName) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + "api/Font/IsExistFont?fontId=" + fontId + '&fontName=' + fontName)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }


  // Certificate Services 
  getAllCertificate(currentPageNumber, currentPageSize, sortOrder, sortName, searchText, schoolId, countryId) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + 'api/Certificate/GetAllCertificate?currentPageNumber=' + currentPageNumber + '&currentPageSize=' + currentPageSize + '&sortOrder=' + sortOrder + '&sortName=' + sortName + '&searchText=' + searchText + '&schoolId=' + schoolId + '&countryId=' + countryId)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  getAllCertificateForDDL(schoolId) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + 'api/Certificate/GetAllCertificateForDDL?schoolId=' + schoolId)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  addCertificateDetails(certificateObj) {
    return new Promise(resolve => {
      this.http.post(this.baseURL + 'api/Certificate/AddCertificateDetails', certificateObj)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  updateCertificateDetails(certificateObj) {
    return new Promise(resolve => {
      this.http.post(this.baseURL + 'api/Certificate/UpdateCertificateDetails', certificateObj)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  getCertificateByCertificateId(certificateId) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + "api/Certificate/GetCertificateByCertificateId?certificateId=" + certificateId)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  isCertificateExist(certificateName, certificateId) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + "api/Certificate/IsCertificateExist?certificateName=" + certificateName + '&certificateId=' + certificateId)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  deleteCertificate(certificateId) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + "api/Certificate/DeleteCertificate?certificateId=" + certificateId)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }


  // Certificate Settings Services
  addCertificateSettings(certificateSettingObj) {
    return new Promise(resolve => {
      this.http.post(this.baseURL + 'api/Certificate/AddCertificateSettings', certificateSettingObj)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  getCertificateSettingByCertificateId(certificateId) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + "api/Certificate/GetCertificateSettingByCertificateId?certificateId=" + certificateId)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }


  // Batch Upload History Services
  getAllBatchUploadHistory(currentPageNumber, currentPageSize, sortOrder, sortName, searchText, schoolId, countryId) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + 'api/Batch/GetAllBatchUploadHistory?currentPageNumber=' + currentPageNumber + '&currentPageSize=' + currentPageSize + '&sortOrder=' + sortOrder + '&sortName=' + sortName + '&searchText=' + searchText + '&schoolId=' + schoolId + '&countryId=' + countryId)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  getBatchUploadHistoryByHistoryId(batchuploadHistoryId) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + "api/Batch/GetBatchUploadHistoryByHistoryId?batchUploadHistoryId=" + batchuploadHistoryId)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  getAllBatchForDDL(schoolId) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + 'api/Batch/GetAllBatchForDDL?schoolId=' + schoolId)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  addBatchUploadHistory(batchUploadHistoryObj) {
    return new Promise(resolve => {
      this.http.post(this.baseURL + 'api/Batch/AddBatchUploadHistory', batchUploadHistoryObj)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  updateBatchUploadHistory(batchUploadItemsObj) {
    return new Promise(resolve => {
      this.http.post(this.baseURL + 'api/Batch/UpdateBatchUploadHistory', batchUploadItemsObj)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  isBatchExist(title, batchHistoryId) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + "api/Batch/IsBatchExist?title=" + title + '&batchHistoryId=' + batchHistoryId)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  deleteBatch(batchHistoryId) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + "api/Batch/DeleteBatch?batchHistoryId=" + batchHistoryId)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }


  // Batch Upload Items Services
  getAllBatchUploadItemsByBatchUploadId(currentPageNumber, currentPageSize, sortOrder, sortName, searchText, batchId) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + 'api/Batch/GetAllBatchUploadItemsByBatchUploadId?currentPageNumber=' + currentPageNumber + '&currentPageSize=' + currentPageSize + '&sortOrder=' + sortOrder + '&sortName=' + sortName + '&searchText=' + searchText +'&batchUploadId=' + batchId)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  adBatchUploadItems(batchUploadItemsObj) {
    return new Promise(resolve => {
      this.http.post(this.baseURL + 'api/Batch/AddBatchUploadItems', batchUploadItemsObj)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }
  
  deleteBatchItem(batchUploadItemsId, userId) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + "api/Batch/DeleteBatchItem?batchUploadItemsId=" + batchUploadItemsId + "&userId=" + userId)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  // Generate Certificate Services
  generateCertificate(generateCertificateModel) {
    return new Promise(resolve => {
      this.http.post(this.baseURL + 'api/Batch/GenerateCertificate', generateCertificateModel)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  reGenerateCertificate(generateCertificateModel) {
    return new Promise(resolve => {
      this.http.post(this.baseURL + 'api/Batch/ReGenerateCertificate', generateCertificateModel)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  getGenerateCertificateLogByCertificateLogId(certificateLogId) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + "api/GenerateCertificate/GetGenerateCertificateLogByCertificateLogId?certificateLogId=" + certificateLogId)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  getAllGeneratedCertificatesByLogId(certificateLogId) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + "api/GenerateCertificate/GetAllGeneratedCertificatesByLogId?certificateLogId=" + certificateLogId)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  getAllGenerateCertificateLog(currentPageNumber, currentPageSize, sortOrder, sortName, searchText,schoolId,countryId) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + 'api/GenerateCertificate/GetAllGenerateCertificateLog?currentPageNumber=' + currentPageNumber + '&currentPageSize=' + currentPageSize + '&sortOrder=' + sortOrder + '&sortName=' + sortName + '&searchText=' + searchText + '&schoolId=' + schoolId + '&countryId=' + countryId)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  downloadCertificates(generatedCertificateItemsObj) {
    return new Promise(resolve => {
      this.http.post(this.baseURL + 'api/GenerateCertificate/DownloadCertificates', generatedCertificateItemsObj)
        .subscribe((data: any) => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  downloadCertificate(fileName) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + 'api/GenerateCertificate/DownloadCertificate?fileName=' + fileName)
        .subscribe((data: any) => {
          resolve(data);
        });    
    }).catch(this.errorHandler);
  }

  emailCertificates(generatedCertificateItemsObj) {
    return new Promise(resolve => {
      this.http.post(this.baseURL + 'api/GenerateCertificate/EmailCertificates', generatedCertificateItemsObj)
        .subscribe((data: any) => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  getGenerateCertificateByGeneratedCertificateId(generatedCertificateId) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + "api/GenerateCertificate/GetGenerateCertificateByGeneratedCertificateId?generatedCertificateId=" + generatedCertificateId)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  isGenerateCertificateTitleExist(title, generateCertificateLogId) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + "api/GenerateCertificate/IsGenerateCertificateTitleExist?title=" + title + '&generateCertificateLogId=' + generateCertificateLogId)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }


  // School Services 
  getAllSchools(currentPageNumber, currentPageSize, sortOrder, sortName, searchText) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + 'api/School/GetAllSchools?currentPageNumber=' + currentPageNumber + '&currentPageSize=' + currentPageSize + '&sortOrder=' + sortOrder + '&sortName=' + sortName + '&searchText=' + searchText)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }


  addSchool(schoolObj) {
    return new Promise(resolve => {
      this.http.post(this.baseURL + 'api/School/AddSchool', schoolObj)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  updateSchool(schoolObj) {
    return new Promise(resolve => {
      this.http.post(this.baseURL + 'api/School/UpdateSchool', schoolObj)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  getSchoolBySchoolId(schoolId) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + "api/School/GetSchoolBySchoolId?schoolId=" + schoolId)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  isExistSchool(schoolId, schoolName) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + "api/School/IsExistSchool?schoolId=" + schoolId + '&schoolName=' + schoolName)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  deleteSchool(schoolId, userId) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + "api/School/DeleteSchool?schoolId=" + schoolId + "&userId=" + userId)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  getAllSchoolForDDL() {
    return new Promise(resolve => {
      this.http.get(this.baseURL + 'api/School/GetAllSchoolForDDL')
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  getAllSchoolBaseOnRoleForDDL(schoolId, countryId) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + 'api/School/GetAllSchoolBaseOnRoleForDDL?schoolId=' + schoolId + '&countryId=' + countryId)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }


  // User Services
getAllUser(currentPageNumber, currentPageSize, sortOrder, sortName, searchText) {
  return new Promise(resolve => {
    this.http.get(this.baseURL + 'api/User/GetAllUsers?currentPageNumber=' + currentPageNumber + '&currentPageSize=' + currentPageSize + '&sortOrder=' + sortOrder + '&sortName=' + sortName + '&searchText=' + searchText)
      .subscribe(data => {
        resolve(data);
      });
  }).catch(this.errorHandler);
}

getAllUserRoleForDDL() {
  return new Promise(resolve => {
    this.http.get(this.baseURL + 'api/User/GetAllUserRoleForDDL')
      .subscribe(data => {
        resolve(data);
      });
  }).catch(this.errorHandler);
}


  addUser(userObj) {
   
  return new Promise(resolve => {
    this.http.post(this.baseURL + 'api/User/AddUser', userObj)
      .subscribe(data => {
        resolve(data);
      });
  }).catch(this.errorHandler);
}

  updateUser(userObj) {
  return new Promise(resolve => {
    this.http.post(this.baseURL + 'api/User/UpdateUser', userObj)
      .subscribe(data => {
        resolve(data);
      });
  }).catch(this.errorHandler);
  }

  changePassword(userObj) {    
    return new Promise(resolve => {
      this.http.post(this.baseURL + 'api/User/ChangePassword', userObj)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }


  deleteUser(userId, deletedBy) {
  return new Promise(resolve => {
    this.http.get(this.baseURL + "api/User/DeleteUser?userId=" + userId + "&deletedBy=" + deletedBy)
      .subscribe(data => {
        resolve(data);
      });
  }).catch(this.errorHandler);
}

getUserByUserId(id) {
  return new Promise(resolve => {
    this.http.get(this.baseURL + "api/User/GetUserByUserId?id=" + id)
      .subscribe(data => {
        resolve(data);
      });
  }).catch(this.errorHandler);
}

  isExistEmail(userId, email) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + "api/User/IsExistEmail?userId=" + userId + '&email=' + email)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }


  // Country Services 
  getAllCountries(currentPageNumber, currentPageSize, sortOrder, sortName, searchText) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + 'api/Country/GetAllCountries?currentPageNumber=' + currentPageNumber + '&currentPageSize=' + currentPageSize + '&sortOrder=' + sortOrder + '&sortName=' + sortName + '&searchText=' + searchText)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }


  addCountry(countryObj) {
    return new Promise(resolve => {
      this.http.post(this.baseURL + 'api/Country/AddCountry', countryObj)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  updateCountry(countryObj) {
    return new Promise(resolve => {
      this.http.post(this.baseURL + 'api/Country/UpdateCountry', countryObj)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  getCountryByCountryId(countryId) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + "api/Country/GetCountryByCountryId?countryId=" + countryId)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  isExistCountry(countryId, countryName) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + "api/Country/IsExistCountry?countryId=" + countryId + '&countryName=' + countryName)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  deleteCountry(countryId, userId) {
    return new Promise(resolve => {
      this.http.get(this.baseURL + "api/Country/DeleteCountry?countryId=" + countryId + "&userId=" + userId)
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }

  getAllCountryForDDL() {
    return new Promise(resolve => {
      this.http.get(this.baseURL + 'api/Country/GetAllCountryForDDL')
        .subscribe(data => {
          resolve(data);
        });
    }).catch(this.errorHandler);
  }


  // Error Handling
  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  } 
}
